import { Attrs, MinzeElement } from 'minze'

export interface LvcSliderArrowLeftIcon {
  dataColor?: string
}

export class LvcSliderArrowLeftIcon extends MinzeElement {
  attrs: Attrs = [['data-color'], ['width', '47'], ['height', '47']]

  static observedAttributes = ['width', 'height']

  onAttributeChange(
    name?: string | undefined,
    oldValue?: string | null | undefined,
    newValue?: string | null | undefined
  ): void | Promise<void> {
    if (name === 'width' && newValue) {
      this.width = Number(newValue)
    }
    if (name === 'height' && newValue) {
      this.height = Number(newValue)
    }
  }

  html = () => `
    <svg width="${this.width}" height="${this.height}" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5185 23.5822C20.6125 23.6058 21.6174 23.6178 22.6278 23.6512C25.167 23.7307 27.7115 23.8173 30.2508 23.904C31.1565 23.9335 32.0622 23.963 32.9677 23.9781C33.2086 23.985 33.4544 23.9774 33.6885 23.8982C33.9019 23.8268 34.0706 23.5841 34.0078 23.2623C33.9679 23.0621 33.8438 22.8357 33.7114 22.7391C33.5683 22.6284 33.3748 22.6344 33.202 22.6254C32.4372 22.5771 31.6724 22.5289 30.9029 22.5096C27.2487 22.3999 23.5895 22.3047 19.9354 22.2022C19.8045 22.199 19.6676 22.1457 19.5364 22.121C19.3245 21.6455 19.4263 21.1531 19.3978 20.6935C19.3767 20.3632 19.3712 20.0252 19.3136 19.7032C19.2557 19.3669 18.8747 19.1053 18.6409 19.2061C18.5421 19.2451 18.4384 19.3059 18.356 19.3876C17.0537 20.7015 15.5818 21.5673 14.1212 22.4832C13.8415 22.6574 13.568 22.8889 13.3211 23.1484C13.0588 23.4299 13.0736 24.0123 13.3396 24.2774C13.5364 24.4728 13.7586 24.617 13.9806 24.754C15.3279 25.5468 16.6599 26.3617 17.9272 27.3801C18.1605 27.5671 18.4346 27.6881 18.7028 27.7661C19.0078 27.8574 19.2805 27.5755 19.2209 27.1313C19.1374 26.5079 19.4858 26.0582 19.45 25.4694C19.4144 24.8949 19.3788 24.3204 19.5185 23.5822Z" fill="${this.dataColor ? this.dataColor : '#1E007D'}"/>
    </svg>
  `

  css = () => `
  :host {
    width: ${this.width}px;
    height: ${this.height}px;
  }
  `
}
